module.exports = __webpack_public_path__ + "static/flags/AA-2ba865cd61e80dcfa0a2fcb79db6da33.gif";